import ky from 'ky';

export const releazioClient = ky.create({
	prefix: import.meta.env.VITE_RELEAZIO_BASE_URL,
	headers: {
		Authorization: import.meta.env.VITE_RELEAZIO_API_KEY,
	},
	timeout: 5000,
	retry: 0,
});
